import type { CardDefinition } from "../../domain/types/index.js";
import { REWARD_POOLS } from "../../content/index.js";

export type CatalogFilter =
  | "all"
  | "starter"
  | "small"
  | "medium"
  | "large"
  | "worker"
  | "action";

export const CATALOG_FILTERS: readonly { id: CatalogFilter; label: string }[] = [
  { id: "all", label: "すべて" },
  { id: "starter", label: "初期" },
  { id: "small", label: "小規模" },
  { id: "medium", label: "中規模" },
  { id: "large", label: "大規模" },
  { id: "worker", label: "労働者" },
  { id: "action", label: "施策" },
];

export function filterCatalogCards(
  cards: readonly CardDefinition[],
  filter: CatalogFilter,
): CardDefinition[] {
  if (filter === "all") return [...cards];
  if (filter === "worker" || filter === "action") {
    return cards.filter((card) => card.type === filter);
  }
  return cards.filter((card) => card.rewardTier === filter);
}

const POOL_LABELS = {
  small: "小規模",
  medium: "中規模",
  large: "大規模",
} as const;

const REWARD_POOL_ENTRIES = Object.entries(REWARD_POOLS) as [
  keyof typeof REWARD_POOLS,
  (typeof REWARD_POOLS)[keyof typeof REWARD_POOLS],
][];

export function getCardRewardPools(cardId: string): string[] {
  return REWARD_POOL_ENTRIES
    .filter(([, pool]) =>
      (pool.workers as readonly string[]).includes(cardId)
      || (pool.actions as readonly string[]).includes(cardId),
    )
    .map(([size]) => POOL_LABELS[size]);
}

export function rewardCatalogCards(cards: readonly CardDefinition[]): CardDefinition[] {
  return cards.filter((card) => getCardRewardPools(card.id).length > 0);
}
